import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Icon } from 'semantic-ui-react';

const FixedBarStatus = ({
  className, status, name, count, onClick, selected,
}) => {
  const classNames = [
    'tab-status',
  ];
  if (className) {
    classNames.push(className);
  }
  if (status) {
    classNames.push(status);
  }
  if (selected) {
    classNames.push('selected');
  }
  const handleOnClick = (event) => {
    event.preventDefault();
    if (onClick) {
      onClick(status);
    }
  };
  return (
    <Grid.Column
      textAlign="center"
      className={classNames.join(' ')}
      onClick={handleOnClick}
    >
      <p>{count}</p>
      {name}
      {selected ? <Icon name="chevron down" /> : null}
    </Grid.Column>
  );
};

FixedBarStatus.contextTypes = {
  store: PropTypes.object,
};

FixedBarStatus.propTypes = {
  className: PropTypes.string,
  status: PropTypes.string,
  name: PropTypes.string,
  count: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

export default FixedBarStatus;



// WEBPACK FOOTER //
// ./src/components/FixedBarStatus.jsx